import { useContext, useState } from "react";
import { AuthContext } from "../context/authContext";
import axios from "axios";
import { baseUrl } from "../modules/account/login";
import { useNavigate } from "react-router";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type dataType =
  | "leads"
  | "calls"
  | "campaigns"
  | "knowledgebase"
  | "get_leads_summary"
  | "get_call_stats"
  | "get_call_activities";

export default function useFetchData({
  dataType,
  page,
  filter,
}: {
  dataType: dataType;
  page?: number;
  filter?: any;
}) {
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getData = () => {
    const url = filter
      ? `${baseUrl}/${dataType}?${filter}`
      : `${baseUrl}/${dataType}?page=${page}`;
    return axios
      .get(url, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        const data = response.data;
        setLoading(false);
        return data;
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");
        return Promise.reject(
          new Error(e?.message ?? "Check your internet connection")
        );
      });
  };

  const getDashboardDetails = async () => {
    try {
      const response = await axios.get(`${baseUrl}/dashboard/${dataType}`, {
        headers: { Authorization: AuthStr },
      });
      const data = response.data;
      return data;
    } catch (e) {
      if (e?.response?.data?.message === "Session expired")
        navigate("/account/logout");
      return await Promise.reject(
        new Error(e?.message ?? "Something went wrong")
      );
    }
  };

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: [dataType, token, filter],
    queryFn: () =>
      dataType !== "get_leads_summary" &&
      dataType !== "get_call_stats" &&
      dataType !== "get_call_activities"
        ? getData()
        : getDashboardDetails(),
    placeholderData: keepPreviousData,
  });

  return { data, error, isLoading, loading, refetch };
}
